import { AppLayoutTitle } from "@app/components/sparkle/AppLayoutTitle";
import { Button, cn } from "@dust-tt/sparkle";
import { useLingui } from "@lingui/react/macro";
import type React from "react";

interface AgentActionsPanelHeaderProps {
  children?: React.ReactNode;
  onClose?: () => void;
  closeIcon: React.ComponentType<{}>;
  title: string;
}

export function AgentActionsPanelHeader({
  children,
  closeIcon,
  onClose,
  title,
}: AgentActionsPanelHeaderProps) {
  const { t } = useLingui();
  return (
    <AppLayoutTitle className="@container">
      <div className="flex h-full min-w-0 max-w-full items-center justify-between gap-2">
        {/* Progressive content visibility based on container width. */}
        <div className="flex min-w-0 items-center gap-2 overflow-hidden">
          {/* Title - visible from xxxs container width. */}
          <span
            className={cn(
              "hidden min-w-0 truncate text-sm font-normal @xxxs:inline",
              "text-primary"
            )}
          >
            {title}
          </span>
        </div>

        {/* Actions - always visible and right-aligned. */}
        <div className="flex shrink-0 items-center gap-2">
          {children}
          {onClose && (
            <Button
              tooltip={t`Close`}
              variant="ghost"
              size="sm"
              onClick={onClose}
              icon={closeIcon}
              className="text-element-600 hover:text-element-900"
            />
          )}
        </div>
      </div>
    </AppLayoutTitle>
  );
}
